import React, { useEffect, useState } from 'react'
import MySpiner from '../../../../../UI/spiner/MySpiner'
import MySelect from '../../../../../UI/form/MySelect'
import { responseError } from '../../../../../../helpers/response/ResponseHelper'
import { getGoodsByFactoryLineIdAndPackIdAllAPI } from '../../../../../../api/products/goodAPI'

const GoodSelectSeriesInPack = ({ packId, factoryLineId, required, setValidate, setValueForm, forciblyValue }) => {

  	const [value, setValue] = useState(forciblyValue)
	const [goods, setGoods] = useState([])

	const [loading, setLoading] = useState(false)

	useEffect(() => {
		getGoodTypes()
	}, [packId, factoryLineId])

	useEffect(() => {
		valid()
	}, [required, value])

	const getGoodTypes = () => {
		setValueForm(null)
		setValue('')
		if (factoryLineId) {
			setLoading(true)
			getGoodsByFactoryLineIdAndPackIdAllAPI({ packId, factoryLineId }).then(data => {
				setGoods(data)
				setLoading(false)
			}).catch(e => {
				// setError(responseError(e))
				setLoading(false)
				console.error(responseError(e))
			})
		}
	}

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
			} else {
				setValidate(false)
			}
		} else {
			setValidate(true)
		}
	}

  return (
	<>
		{
			loading ?
				<MySpiner />
			:
				<MySelect
					value={value}
					label="Товар"
					labelId="select__good-label"
					id='select__good'
					onChange = {e => {
						setValueForm(e)
						setValue(e)
						// setEvent({...event, categoryId: e})
					}}
					nameField='Товар'
					// sx={{width: '200px'}}
					options={
						goods && goods.length > 0 ? 
							goods.map(good => {
								return {id: good.id, name: good.name}
							})
						: []	
					}
					// options={[]}
				/>
		}
	</>
  )
}

export default GoodSelectSeriesInPack